"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesIO = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyUtils_1 = require("./SankeyUtils");
const fa_1 = require("react-icons/fa");
// Search links coming from/going to(io) from a face of it (pos) and return them
const getIOLink = (data, multi_selected_nodes, pos, io, getLinkValue) => {
    const n = multi_selected_nodes.current[0];
    let link_io = [];
    if (io == 'input') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            link_io = Object.values(n.inputLinksId).filter(k => {
                const n_s = data.nodes[data.links[k].idSource];
                const cond_no_recy = (((n_s.x <= n.x && n_s.position != 'relative') || (n_s.position == 'relative' && n_s.x < 0)) && !data.links[k].recycling);
                const cond_recy = (data.links[k].recycling && n_s.x > n.x);
                return (cond_no_recy || cond_recy) && (data.links[k].orientation == 'hh' || data.links[k].orientation == 'vh') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            link_io = Object.values(n.inputLinksId).filter(k => {
                const n_s = data.nodes[data.links[k].idSource];
                const cond_no_recy = (((n_s.x >= n.x && n_s.position != 'relative') || (n_s.position == 'relative' && n_s.x > 0)) && !data.links[k].recycling);
                const cond_recy = (data.links[k].recycling && n_s.x < n.x);
                return (cond_no_recy || cond_recy) && (data.links[k].orientation == 'hh' || data.links[k].orientation == 'vh') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.inputLinksId).filter(k => {
                const n_s = data.nodes[data.links[k].idSource];
                return n_s.y < n.y && (data.links[k].orientation == 'vv' || data.links[k].orientation == 'hv') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.inputLinksId).filter(k => {
                const n_s = data.nodes[data.links[k].idSource];
                return n_s.y >= n.y && (data.links[k].orientation == 'vv' || data.links[k].orientation == 'hv') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const n_t = data.nodes[data.links[k].idTarget];
                const cond_no_recy = (((n_t.x < n.x && n_t.position != 'relative') || (n_t.position == 'relative' && n_t.x <= 0)) && !data.links[k].recycling);
                const cond_recy = (data.links[k].recycling && n_t.x > n.x);
                return ((cond_no_recy || cond_recy)) && (data.links[k].orientation == 'hh' || data.links[k].orientation == 'hv') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const n_t = data.nodes[data.links[k].idTarget];
                const cond_no_recy = (((n_t.x >= n.x && n_t.position != 'relative') || (n_t.position == 'relative' && n_t.x > 0)) && !data.links[k].recycling);
                const cond_recy = (data.links[k].recycling && n_t.x < n.x);
                return (cond_no_recy || cond_recy) && (data.links[k].orientation == 'hh' || data.links[k].orientation == 'hv') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const n_t = data.nodes[data.links[k].idTarget];
                return n_t.y < n.y && (data.links[k].orientation == 'vv' || data.links[k].orientation == 'vh') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const n_t = data.nodes[data.links[k].idTarget];
                return n_t.y >= n.y && (data.links[k].orientation == 'vv' || data.links[k].orientation == 'vh') && SankeyUtils_1.link_visible(data.links[k], data, getLinkValue);
            });
        }
    }
    return link_io;
};
/**
   * Switch the link with the one on top of him (similar to drag link)
   *
   * @param {string} k_link
   * @param {string} pos
   * @param {string} io
   */
const handleUpLinkIOPos = (data, set_data, multi_selected_nodes, k_link, pos, io, getLinkValue) => {
    const n = multi_selected_nodes.current[0];
    const link_io = getIOLink(data, multi_selected_nodes, pos, io, getLinkValue);
    if (io == 'input') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Recherche tous les flux sortant a gauche
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Recherche tous les flux sortant a droite
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Recherche tous les flux sortant en haut
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux sortant en bas
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    set_data(Object.assign({}, data));
};
/**
   * Switch the link with the one below him (similar to drag link)
   *
   * @param {string} k_link
   * @param {string} pos
   * @param {string} io
   */
const handleDownLinkIOPos = (data, set_data, multi_selected_nodes, k_link, pos, io, getLinkValue) => {
    const n = multi_selected_nodes.current[0];
    const link_io = getIOLink(data, multi_selected_nodes, pos, io, getLinkValue);
    if (io == 'input') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Recherche tous les flux sortant a gauche
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Recherche tous les flux sortant a droite
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Recherche tous les flux sortant en haut
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux sortant en bas
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    set_data(Object.assign({}, data));
};
/**
   * Check if the selected node has links coming from/going to(io) from a face of it (pos)
   *
   * @param {string} io
   * @param {string} pos
   * @returns {boolean}
   */
const has_link_come_from = (data, set_data, multi_selected_nodes, io, pos, getLinkValue) => {
    const link_io = getIOLink(data, multi_selected_nodes, pos, io, getLinkValue);
    return link_io.length == 0;
};
/**
   * Create a html table displaying links attached to the selected node and filtered by where they're coming/going from
   *
   * @param {string} pos
   * @param {string} io
   * @returns {*}
   */
const tab_pos_link = (t, data, set_data, multi_selected_nodes, pos, io, tab_colored, getLinkValue) => {
    const link_io = getIOLink(data, multi_selected_nodes, pos, io, getLinkValue);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, className: 'node_group_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, t('Menu.flux')),
                    react_1.default.createElement("th", null, t('Tags.Position')))),
            react_1.default.createElement("tbody", null, link_io.map((k, i) => {
                const color = SankeyUtils_1.link_color(data.links[k], data, getLinkValue);
                const bc = { 'backgroundColor': (color && tab_colored) ? color : 'inherit' };
                const n_s = data.nodes[data.links[k].idSource];
                const n_t = data.nodes[data.links[k].idTarget];
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: bc }, n_s.name + '===>' + n_t.name),
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "button_position", size: "sm" },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleUpLinkIOPos(data, set_data, multi_selected_nodes, k, pos, io, getLinkValue) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleUp, null)),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleDownLinkIOPos(data, set_data, multi_selected_nodes, k, pos, io, getLinkValue) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleDown, null))))));
            })))));
};
const SankeyMenuConfigurationNodesIO = (t, data, set_data, multi_selected_nodes, link_io, set_link_io, link_pos, set_link_pos, tab_colored, set_tab_colored, getLinkValue) => {
    // const [link_io,set_link_io]=useState<string>('output')
    // const [link_pos,set_link_pos]=useState<string>('right')
    // const [tab_colored,set_tab_colored]=useState<boolean>(false)
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "node_link_io", title: t('Noeud.PF.PF') },
        react_1.default.createElement(react_bootstrap_1.Form, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.PF.FES'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.1' },
                            t('Noeud.PF.tooltips.sort'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "output", type: 'radio', label: t('Noeud.PF.sort'), checked: link_io == 'output', onChange: () => {
                                set_link_io('output');
                                set_link_pos('');
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.2' },
                            t('Noeud.PF.tooltips.ent'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "input", type: 'radio', label: t('Noeud.PF.ent'), checked: link_io == 'input', onChange: () => {
                                set_link_io('input');
                                set_link_pos('');
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.PF.FRN'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.3' },
                            t('Noeud.PF.tooltips.gauche'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: has_link_come_from(data, set_data, multi_selected_nodes, link_io, 'left', getLinkValue), value: "left", type: 'radio', label: t('Noeud.PF.gauche'), checked: link_pos == 'left', onChange: () => {
                                set_link_pos('left');
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.4' }, t('Noeud.PF.tooltips.droite')) },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: has_link_come_from(data, set_data, multi_selected_nodes, link_io, 'right', getLinkValue), value: "right", type: 'radio', label: t('Noeud.PF.droite'), checked: link_pos == 'right', onChange: () => {
                                set_link_pos('right');
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.5' }, t('Noeud.PF.tooltips.ades')) },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: has_link_come_from(data, set_data, multi_selected_nodes, link_io, 'top', getLinkValue), value: "top", type: 'radio', label: t('Noeud.PF.ades'), checked: link_pos == 'top', onChange: () => {
                                set_link_pos('top');
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.6' }, t('Noeud.PF.tooltips.edes')) },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: has_link_come_from(data, set_data, multi_selected_nodes, link_io, 'bottom', getLinkValue), value: "bottom", type: 'radio', label: t('Noeud.PF.edes'), checked: link_pos == 'bottom', onChange: () => {
                                set_link_pos('bottom');
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.PF.lti'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.7' }, t('Noeud.PF.tooltips.lti')) },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "bottom", type: 'checkbox', label: t('Noeud.PF.col'), checked: tab_colored, onChange: () => {
                                //console.log(tab_colored)
                                set_tab_colored(!tab_colored);
                            } }))))),
        tab_pos_link(t, data, set_data, multi_selected_nodes, link_pos, link_io, tab_colored, getLinkValue));
};
exports.SankeyMenuConfigurationNodesIO = SankeyMenuConfigurationNodesIO;
